<ng-container *ngIf="cardForm">
    <form [formGroup]="cardForm">
        <div class="mt-5 flex flex-col" formControlNameSelector="cardNr">
            <mat-form-field class="w-full" [color]="showCardNumberError ? 'warn' : 'primary'" appearance="outline">
                <mat-label>{{ 'RELATED_CARD_DETAIL_CARD_NUMBER' | translate }} *</mat-label>
                <input matInput formControlName="cardNr" />
                <mat-icon *ngIf="cardNumberValid" [ngStyle]="{ color: '#39E326' }" matSuffix>check</mat-icon>
            </mat-form-field>
            <p class="px-2 text-xs text-[#E31D17] dark:text-contrast-yellow" *ngIf="showCardNumberError">
                <span *ngIf="cardForm?.get('cardNr')?.hasError('required')">
                    {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                </span>
                <span *ngIf="cardForm?.get('cardNr')?.hasError('pattern')">
                    {{ 'FIELD_VALIDATION_CARD_NUMBER_INVALID_FORMAT' | translate }}
                </span>
            </p>
        </div>

        <div class="mt-5 flex flex-col" *ngIf="mode === 'add' && !hidePinField" formControlNameSelector="cardPin">
            <mat-form-field class="w-full" [color]="showCardPinError ? 'warn' : 'primary'" appearance="outline">
                <mat-label>{{ 'CARD_PIN_NR' | translate }} *</mat-label>
                <input matInput formControlName="cardPin" />
                <mat-icon *ngIf="cardPinValid" [ngStyle]="{ color: '#39E326' }" matSuffix>check</mat-icon>
            </mat-form-field>
            <p class="px-2 text-xs text-[#E31D17] dark:text-contrast-yellow" *ngIf="showCardPinError">
                <span *ngIf="cardForm?.get('cardPin')?.hasError('required')">
                    {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                </span>
                <span *ngIf="cardForm?.get('cardPin')?.hasError('pattern')">
                    {{ 'FIELD_VALIDATION_CARD_NUMBER_INVALID_FORMAT' | translate }}
                </span>
                <span *ngIf="cardForm?.get('cardPin')?.hasError('minlength')">
                    {{ 'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate }}
                </span>
                <span *ngIf="cardForm?.get('cardPin')?.hasError('maxlength')">
                    {{ 'LOCAL_INPUT_VALIDATION_MAX_LENGTH' | translate }}
                </span>
            </p>
        </div>

        <div class="mt-5 flex flex-col" formControlNameSelector="name">
            <mat-form-field class="w-full" [color]="showCardNameError ? 'warn' : 'primary'" appearance="outline">
                <mat-label>{{ 'PH_CARD_NAME' | translate }} *</mat-label>
                <input matInput formControlName="name" />
                <mat-icon *ngIf="cardNameValid" [ngStyle]="{ color: '#39E326' }" matSuffix>check</mat-icon>
            </mat-form-field>
            <p class="text-old_silver px-3 text-xs font-medium dark:text-contrast-yellow">
                {{ 'CARD_NAME_WILL_HELP_WITH_MULTIPLE_CARDS' | translate }}
            </p>
        </div>

        <div class="mt-5 flex flex-col" *ngIf="showDiscounts" formControlNameSelector="discountGroup">
            <mat-form-field class="w-full" appearance="outline">
                <mat-label>{{ 'RELATED_CARD_DETAIL_DISCOUNT' | translate }} *</mat-label>
                <mat-select formControlName="discountGroup">
                    <mat-option *ngFor="let option of discountGroupOptions" [value]="option.group_id">
                        {{ option | translateObjectField: 'name' : locale }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <p class="px-3 text-xs font-medium text-[#5E5E5E] dark:text-contrast-yellow">
                {{ 'DISCOUNT_GROUP_DESCRIPTION' | translate }}
            </p>
        </div>
    </form>
</ng-container>
